var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var deepmerge = require('deepmerge');
import { theme as defaultTheme } from '../theme/theme';
import { createTextStyles, createColorStyles, createMediaQueries, createPalette } from '.';
/**
 * Adds aliases to an array of keys
 *
 * @param arr - The array to add aliases to
 */
var addAliases = function (arr) {
    arr.forEach(function (val, key) {
        arr[['sm', 'md', 'lg', 'xl', 'xxl'][key]] = val;
    });
    return arr;
};
/**
 * Create the theme
 *
 * @param theme -             The theme to merge against the default
 * @param customBreakpoints - Custom breakpoints for the theme
 *
 * @returns The generated theme
 */
var createTheme = function (theme, customBreakpoints) {
    if (theme === void 0) { theme = {}; }
    if (customBreakpoints === void 0) { customBreakpoints = null; }
    var mergedTheme = deepmerge(defaultTheme, theme);
    var mediaQueries = customBreakpoints ? createMediaQueries(customBreakpoints) : mergedTheme.mediaQueries;
    return __assign(__assign({}, mergedTheme), { contrastRatio: mergedTheme.contrastRatio || 2.6, breakpoints: addAliases(customBreakpoints || mergedTheme.breakpoints), mediaQueries: addAliases(mediaQueries), palette: createPalette(mergedTheme), colorStyles: createColorStyles(mergedTheme), textStyles: createTextStyles(mergedTheme) });
};
export { createTheme };
//# sourceMappingURL=createTheme.js.map